import { FilterKeyTypes } from "../../shared/types/FilterKeys.types";

export const COUNT_OF_SHEET_INSTRUCTION_ROWS = 9;
export const HEADER_ROWS_COUNT = 6;
export const HEADER_ROWS_COUNT_WITHOUT_INSTRUCTIONS = 3;
export const EXCEL_BASE_DATE = 25567;
export const EXTRA_ROWS = 30;
export const MAX_RECORDS_FOR_SHEET = 1000000;
export const MAX_ROW_SIZE = 120;
export const ROW_SIZE_FOR_API_CALL = 50;
export const TASK_POLLING_INTERVAL = 2000;
export const SCROLL_THRESHOLD_VALUE = 50;

export const CONDITION_TRUE = "Yes";
export const CONDITION_FALSE = "No";
export const SCROLL_EVENT_LISTENER_TYPE = "scroll";

//Place holder text for the base components
export const ACCOUNTS_PLACEHOLDER = "Accounts";
export const CHART_OF_ACCOUNTS_PLACEHOLDER = "Chart of Accounts";
export const CLIENT_ENGAGEMENT_ENTITY_PLACEHOLDER = "Client-Engagement-Entity";
export const DEFAULT_SELECT_PLACEHOLDER = "Select...";
export const USERNAME_PLACEHOLDER = "Username";
export const PASSWORD_PLACEHOLDER = "Password";
export const ENTITY_PROJECT_PLACEHOLDER = "Entity Projects";
export const FETCHING_FILTERS_PLACEHOLDER = "Fetching filters if available";
export const LOADING_PLACEHOLDER = "Loading...";
export const NO_COA_PLACEHOLDER = "No Coa Found";
export const NO_COMBINATION_FOUND_PLACEHOLDER = "No Combination Found";
export const NO_DATA_PLACEHOLDER = "No data found";
export const NO_MATCHES_FOUND_PLACEHOLDER = "No matches found...";
export const NO_OPTIONS_FOUND_PLACEHOLDER = "No options found";
export const NO_PROJECTS_FOUND_PLACEHOLDER = "No data found...";
export const NO_RULE_ENGINE_PLACEHOLDER = "No Rule Engine Found";
export const PROJECT_MENU_PLACEHOLDER = "Project Menu";
export const PROJECT_PLACEHOLDER = "Project";
export const RULE_ENGINE_PLACEHOLDER = "Rule Engine";
export const SHEET_DOESNOT_EXIST_PLACEHOLDER = "Sheet does not exist";
export const FILTER_OPTIONS_PLACEHOLDER = "Filter Options";
export const IS_SHEET_CHANGED = "Do you want to save the unsaved changes?";
//Navigation tab names
export const NAVIGATION_TABS = [
  "Deliverables",
  "Templates",
  "Chart of Accounts",
  "Administration",
];

// Keys for the base components
export const EXCEL_VIEW_ROUTE_KEY = "Allocation";
export const LANDING_ROUTE_KEY = "Landing";
export const LOGIN_ROUTE_KEY = "Login";
export const PROJECT_TYPE_REF_KEY = "projectType";
export const TAX_END_YEAR_REF_KEY = "taxEndYear";
export const TAX_START_YEAR_REF_KEY = "taxStartYear";
export const TAX_YEAR_TYPE_REF_KEY = "taxYearType";
export const USER_NAME_KEY = "userNameValue";
export const USER_PASSWORD_KEY = "userSecretValue";
export const LOGOUT = "Log Out";
export const MULTI_SHEET_KEY = "multiSheet";
export const NAVBAR_KEY = "navbar";

// Status message for the components
export const IMPORT_IN_PROGRESS_MESSAGE =
  " There is an import task for this project which is in progress. Please try after some time.";
export const IMPORT_TASK_PENDING_MESSAGE = "Import task is in progress.";
export const SAVE_TASK_PENDING_MESSAGE = "Save task is in progress.";
export const NO_SHEETS_IN_HIERARCHY = "No sheets to display...";
export const TOAST_CONTAINER_CLASS = "mainContainerToast";
export const TOAST_DEFAULT_ERROR_MESSAGE = "Something went wrong";
export const TOAST_DELIVERABLE_CREATED_MESSAGE =
  "Deliverable created successfully.";
export const TOAST_POSITION = "top-center";
export const UNSUPPORTED_FUNCTION_MESSAGE = "Unsupported function";
export const UNSUPPORTED_NODE_TYPE_MESSAGE = "Unsupported node type";

// Labels values for the components
export const CREATE_DELIVERABLE_BUTTON_LABEL = "Create Deliverable";
export const IMPORT_TEMPLATE_BUTTON_LABEL = "Import Template";
export const CREATE_TEMPLATE_BUTTON_LABEL = "Create Template";
export const CREATE_COA_BUTTON_LABEL = "Create CoA";
export const ENGINE_NAME_LABEL = "Engine Name";
export const CREATE_NEW_DELIVERABLE_LABEL = "Create New Deliverable";
export const NEW_TEMPLATE_LABEL = "New Template";
export const NEW_COA_LABEL = "New CoA Template";
export const DELIVERABLE_NAME_LABEL = "Deliverable Name";
export const TEMPLATE_NAME_LABEL = "Template Name";
export const COA_NAME_LABEL = "CoA Name";
export const GLOBAL_TEMPLATE_LABEL = "Global Template";
export const GLOBAL_COA_LABEL = "Global Chart of Accounts";
export const CLIENT_NAME_LABEL = "Client ";
export const ENGAGEMENT_NAME_LABEL = "Engagement";
export const TAX_YEAR_NAME_LABEL = "Tax Year";
export const PROJECT_TYPE_LABEL = "Project Type";
export const TAX_YEAR_END_DATE_LABEL = "Tax Year End Date";
export const TAX_YEAR_START_DATE_LABEL = "Tax Year Start Date";
export const TAX_YEAR_TYPE_LABEL = "Tax Year Type";
export const USER_NAME_LABEL = "User Name";
export const USER_PASSWORD_LABEL = "Password";
export const FILTER_NAME_LABEL = "Name";
export const FILTER_TEMPLATE_LABEL = "Template";
export const FILTER_COA_LABEL = "CoA";
export const FILTER_CREATED_ON_LABEL = "Created On";
export const FILTER_CREATED_BY_LABEL = "Created By";
export const NO_OF_DELIVERABLES_LABEL = "No. of Deliverables";
export const FILTER_TAGS_LABEL = "Tags";
export const IMPORT_BUTTON_LABEL = "Import";
export const EXPORT_BUTTON_LABEL = "Export";
export const CANCEL_TEXT = "Cancel";
export const CREATE_TEXT = "Create";
export const SAVE_TEXT = "Save";
export const ADDROW_TEXT = "Add Row";
export const EDIT_ONLINE_TEXT = "Edit Online";
export const VERSION = "v1.7";
export const CANCEL_BUTTON_LABEL = String.fromCharCode(0x2716);
export const APPLY_BUTTON_LABEL = String.fromCharCode(0x2714);
export const APPLY_TEXT = "Apply";
export const CLOSE_TEXT = "Close";
export const CLEAR_FILTER_TEXT = "Clear Filter";

//Required text values for the input components
export const USERNAME_AND_PASSWORD_REQUIRED_TEXT =
  "UserName and Password is required";
export const USERNAME_REQUIRED_TEXT = "UserName is required";
export const PASSWORD_REQUIRED_TEXT = "Password is required";
export const INVALID_CREDENTIALS = "Invalid credentials";
export const INVALID_USERNAME = "Invalid User name";
export const UNEXPECTED_ERROR = "An unexpected error occurred";
export const MINIMUM_3_CHARACTERS = "Please fill minimum 3 characters";

export enum ExcelFormulaNodeType {
  FUNCTION = "function",
  BINARY_EXPRESSION = "binary-expression",
  CELL = "cell",
  NUMBER = "number",
  TEXT = "text",
}
export enum TaskStatus {
  COMPLETED = "completed",
  IN_PROGRESS = "inprogress",
  FAILED = "failed",
  NO_TASK_FOUND = "No Task Found",
}
export enum TaskType {
  IMPORT = "import",
  RERUN = "RERUN",
}
export const FILTER_ITEMS_PROJECT: string[] = [
  "Clients",
  "Engagements",
  "Entity",
  "Tax Year",
];
export const PATHS_WITH_NO_SIDEBAR = ["login", "project"];
export const ACTIVE_TABS_KEY = "activeTab";
export const NAME_KEY = "templateName";
export const TEMPLATE = "template";
export const DEFAULT_DATE_FORMAT = "d-MMM-yy";
export const CHARACTERS_FOR_GETTING_COLUMN_INDEX = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const DEFAULT_GUID = "00000000-0000-0000-0000-000000000000";
export const ITEMS_PER_PAGE = 10;

//Regex patterns used in the application
export const CELL_FORMULA_ROW_INDEX_INDETIFIER_REGEX = /[A-Za-z]{1,2}(?:\d+)/g;
export const CELL_ROW_INDEX_REPLACER_REGEX = /\d+/;
export const COLUMN_IDENTIFIER_REGEX = /[A-Za-z]+/;
export const DATE_REGEX = /^(?=.*d)(?=.*m)(?=.*y).+$/;
export const PERCENTAGE_END_REGEX = /%$/;
export const ROW_IDENTIFIER_REGEX = /\d+/;
export const ALPHANUMERICAL_IDENTIFIER_REGEX = /[A-Za-z]/;

//Error messages
export const TEMPLATE_NOT_FOUND = "Template Not Found";
export const OPTION_NOT_FOUND = "Option Not Found";
export const NO_ACTIVE_SHEET = "No active sheet found.";
//Deliverable Menu  constants
export const DASHBOARD = "Dashboard";
export const USER_ACCESS = "User Access";
export const DELIVERABLE_NAME_UPDATED = "Deliverable name updated successfully";

//Excel view constants
export const IMPORT_SUCCESS_MESSAGE = "Imported successfully";
export const IMPORT_FAILED_MESSAGE = "Import failed";
export const SAVE_SUCCESS = "Changes saved successfully";
export const SAVE_ERROR = "Error while saving";

//User Access constants

export const WRITE_ACCESS = "Write";
export const ACCESS_TYPE = "Access Type";

//Create Template constants
export const TEMPLATE_CREATED_MESSAGE = "Template created successfully";
export const COA_CREATED_MESSAGE = "CoA created successfully";
export const SELECT_FILE_TO_UPLOAD = "Please select a file to upload";
export const ATTACH_FILE = "Please attach a .xlsx file";
export const SELECT_TEMPLATE_MESSAGE = "Please select Template";
export const ENTER_DELIVERABLE_NAME_MESSAGE =
  "Please enter your Deliverable Name";
export const CREATE_TEMPLATE = "Create Template";
export const CREATE_COA = "Create CoA";
export const DELIVERABLE_CREATED = "Deliverable created successfully";
export const ENTER_DELIVERABLE_NAME = "Enter Deliverable Name";
export const SELECT_TEMPLATE = "Select Template";
export const SELECT_COA = "Select CoA";
export const SELECT_TAG = "Select Tag";

//Default filter keys
export const DEFAULT_FILTER_KEYS: FilterKeyTypes = {
  Key1: "",
  Key2: "",
  Key3: "",
  Key4: "",
};

export const SESSION_USERNAME = "userName";
